module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0008-931b3b3e61d43c803769b42bb0dd24eb.jpg";